// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_QXg","cls2":"FocusedNavView-cls2_z7l FocusedNavView-cls1_QXg"};